// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__VtOJY","spinner":"Preloader_spinner__C_tGc","spin":"Preloader_spin__0tf6w"};